document.addEventListener("click", (s) => {
  const e = s.target;
  if (e != null && e.hasAttribute("data-manage-consent") && (s.preventDefault(), window.consentBanner)) {
    window.consentBanner.showConsentPreferences();
    const n = document.querySelectorAll(
      "modal-dialog[open]"
    );
    n.length > 0 && n.forEach((o) => {
      o.closeAllModals();
    });
  }
});
const d = async (s) => {
  const e = document.getElementById("modal-consent"), n = setInterval(() => {
    if (typeof e.openModal != "function")
      return;
    clearInterval(n), e.openModal();
    const o = e.querySelector(
      "[data-consent-categories]"
    );
    o.innerHTML = "", s.forEach((t) => {
      const c = document.createElement("div");
      c.innerHTML = `<span>${t.toUpperCase()}</span>`, o.appendChild(c);
    });
  }, 100);
}, u = (s, e, n = ["marketing", "analytics"], o = !1, t = !1) => {
  window.Shopify.loadFeatures(
    [
      {
        name: "consent-tracking-api",
        version: "0.1"
      }
    ],
    (c) => {
      if (c)
        throw c;
      const a = window.Shopify.customerPrivacy.currentVisitorConsent();
      if (n.every(
        (l) => a[l] === ""
      )) {
        if (o) {
          t && console.log("User was undecided, opening consent modal"), d(n);
          return;
        }
        t && console.log("User was undecided, calling noConsentCallback"), e && e();
        return;
      }
      if (!n.every(
        (l) => a[l] === "yes"
      )) {
        if (o) {
          t && console.log("User has declined, opening consent modal"), d(n);
          return;
        }
        t && console.log("User was undecided, calling noConsentCallback"), e && e();
        return;
      }
      t && console.log("User consented, calling consent callback"), s();
    }
  );
}, f = (s, e, n = ["marketing", "analytics"], o = !1) => {
  const t = (c) => {
    o && console.log("Event: ", c.detail), o && console.log("categories: ", n), n.every((r) => {
      const i = r + "Allowed";
      return c.detail[i] === !0;
    }) ? (o && console.log("Cookies changed to consented, running consentCallback"), s()) : (o && console.log(
      "Cookies changed to NOT consented, running noConsentCallback"
    ), e && e());
  };
  document.addEventListener(
    "visitorConsentCollected",
    t
  );
};
export {
  f as a,
  u
};
